import { useTranslation } from 'react-i18next'
import { ExplainerBanner } from '@/ds'
import { useLoadedStay } from '@/app/stay/StayProvider'
import { ContactRows } from './ContactRows'
import './NotAvailable.css'

export interface NotAvailableProps {
  /** Qué supone para el huésped (una frase por capacidad), p. ej. "Te seguirán llegando todos los avisos." */
  consequences?: string[]
  /** Mensaje de WhatsApp tras la referencia */
  message?: string
  className?: string
}

/**
 * Lo que la API actual aún no permite hacer desde la app (D36, D48, D51, D53): una sola redacción en todas las
 * pantallas, lo que supone para el huésped y siempre el contacto con la propiedad.
 */
export function NotAvailable({ consequences = [], message, className }: NotAvailableProps) {
  const { t } = useTranslation()
  const stay = useLoadedStay()
  return (
    <div className={['hp-notavailable', className].filter(Boolean).join(' ')}>
      <ExplainerBanner title={t('v2.noDisponible.titulo')}>
        {[...consequences, t('v2.noDisponible.texto')].join(' ')}
      </ExplainerBanner>
      <ContactRows whatsapp={stay.contact.whatsapp} phone={stay.contact.supportPhone} reference={stay.reference} {...(message ? { message } : {})} />
    </div>
  )
}
